import moment from 'moment';

import { SupervisionNoteStatus } from '../../../../../constants';

import type { IClient, IParentSupervision } from '../../../../../utils/types';

const DEFAULT_CLIENT: IClient = {
  first_name: '',
  last_name: '',
  middle_name: '',
  sex: '',
  dob: '',
  email: null,
  street_address_line_one: '',
  street_address_line_two: '',
  street_address_zip: '',
  street_address_city: '',
  street_address_state: '',
  phone: '',
};

export const DEFAULT_PARENT_SUPERVISION: IParentSupervision = {
  client: DEFAULT_CLIENT,
  bcba: { email: '', first_name: '', last_name: '' },
  date_start: moment(),
  location: '',
  setting: '',
  version: 'v2',
  target_progress: [],
  goals_and_targets_adhered: false,
  client_id: 0,
  parent_one_parent_and_caregiver_id: 0,
  parent_two_parent_and_caregiver_id: 0,
  status: SupervisionNoteStatus.Started,
  active_treatment_plan_id: 0,
};

export const TIME_RANGE_VALIDATION_RESULTS = {
  VALID: 'valid',
  DURATION_OUT_OF_RANGE: 'duration_out_of_range',
  RATE_OUT_OF_RANGE: 'rate_out_of_range',
} as const;
